/**
 * @description
 * Button icon position type
 * @enum {string}
 * @property {string} LEFT - Left position
 * @property {string} RIGHT - Right position
 * @example
 * <Button iconPosition={IconPositionType.LEFT} />
 * <Button iconPosition={IconPositionType.RIGHT} />
 */
export var IconPositionType;
(function (IconPositionType) {
    IconPositionType["LEFT"] = "LEFT";
    IconPositionType["RIGHT"] = "RIGHT";
})(IconPositionType || (IconPositionType = {}));
//# sourceMappingURL=buttonIconPosition.js.map